import { render, staticRenderFns } from "./PrescriberRegistrationForm.vue?vue&type=template&id=868cdcf4&scoped=true"
import script from "./PrescriberRegistrationForm.vue?vue&type=script&lang=js"
export * from "./PrescriberRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868cdcf4",
  null
  
)

export default component.exports